import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BarrierSvg = (props) => (
  <SvgIcon viewBox="0 0 60 59" {...props}>
    <g fill="none" id="038---Barrier">
      <path
        d="m4 26c-.55228475 0-1-.4477153-1-1v-5c0-.5522847.44771525-1 1-1s1 .4477153 1 1v5c0 .5522847-.44771525 1-1 1z"
        fill="#7f8c8d"
        id="Shape"
      />
      <path
        d="m56 26c-.5522847 0-1-.4477153-1-1v-5c0-.5522847.4477153-1 1-1s1 .4477153 1 1v5c0 .5522847-.4477153 1-1 1z"
        fill="#7f8c8d"
        id="Shape"
      />
      <path d="m27 15.99h6v12.01h-6z" fill="#805333" id="Rectangle-path" />
      <path d="m3 39h6v17h-6z" fill="#95a5a5" id="Rectangle-path" />
      <path d="m51 39h6v17h-6z" fill="#95a5a5" id="Rectangle-path" />
      <rect
        fill="#7f8c8d"
        height="5"
        id="Rectangle-path"
        rx="1"
        width="10"
        x="1"
        y="54"
      />
      <rect
        fill="#7f8c8d"
        height="5"
        id="Rectangle-path"
        rx="1"
        width="10"
        x="49"
        y="54"
      />
      <path
        d="m4 15c-1.1045695 0-2 .8954305-2 2v3h4v-3c0-1.1045695-.8954305-2-2-2z"
        fill="#ff5364"
        id="Shape"
      />
      <path
        d="m56 15c-1.1045695 0-2 .8954305-2 2v3h4v-3c0-1.1045695-.8954305-2-2-2z"
        fill="#7ed09e"
        id="Shape"
      />
      <path
        d="m27 39h6v19c0 .5522847-.4477153 1-1 1h-4c-.5522847 0-1-.4477153-1-1z"
        fill="#805333"
        id="Shape"
      />
      <path
        d="m32.9 1h-5.8c-.5295768.00223279-1.0366497.21441221-1.41.59l-4.1 4.1c-.3755878.37335029-.5877672.88042315-.59 1.41v5.8c.0022328.5295768.2144122 1.0366497.59 1.41l4.1 4.1c.3733503.3755878.8804232.5877672 1.41.59h5.8c.5295768-.0022328 1.0366497-.2144122 1.41-.59l4.1-4.1c.3755878-.3733503.5877672-.8804232.59-1.41v-5.8c-.0022328-.52957685-.2144122-1.03664971-.59-1.41l-4.1-4.1c-.3733503-.37558779-.8804232-.58776721-1.41-.59z"
        fill="#f29c1f"
        id="Shape"
      />
      <path
        d="m32.9 20h-5.8c-.7884432-.0059728-1.5428401-.3221011-2.1-.88l-4.12-4.12c-.5578989-.5571599-.8740272-1.3115568-.88-2.1v-5.8c.0059728-.78844323.3221011-1.54284009.88-2.1l4.12-4.12c.5571599-.55789894 1.3115568-.87402715 2.1-.88h5.8c.7884432.00597285 1.5428401.32210106 2.1.88l4.12 4.12c.5578989.55715991.8740272 1.31155677.88 2.1v5.8c-.0059728.7884432-.3221011 1.5428401-.88 2.1l-4.12 4.12c-.5571599.5578989-1.3115568.8740272-2.1.88zm-5.8-18c-.264767.00368349-.5183662.10726627-.71.29l-4.1 4.1c-.1827337.19163379-.2863165.44523302-.29.71v5.8c.0036835.264767.1072663.5183662.29.71l4.1 4.1c.1916338.1827337.445233.2863165.71.29h5.8c.264767-.0036835.5183662-.1072663.71-.29l4.1-4.1c.1827337-.1916338.2863165-.445233.29-.71v-5.8c-.0036835-.26476698-.1072663-.51836621-.29-.71l-4.1-4.1c-.1916338-.18273373-.445233-.28631651-.71-.29z"
        fill="#c03a2b"
        id="Shape"
      />
      <path
        d="m30 12c-.5522847 0-1-.4477153-1-1v-6c0-.55228475.4477153-1 1-1s1 .44771525 1 1v6c0 .5522847-.4477153 1-1 1z"
        fill="#c03a2b"
        id="Shape"
      />
      <circle cx="30" cy="15" fill="#c03a2b" id="Oval" r="1" />
      <path
        d="m7 21h-6c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h6c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
        fill="#95a5a5"
        id="Shape"
      />
      <path
        d="m59 21h-6c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
        fill="#95a5a5"
        id="Shape"
      />
      <rect
        fill="#f0c419"
        height="16"
        id="Rectangle-path"
        rx="2"
        width="58"
        x="1"
        y="25"
      />
      <g fill="#393f4a">
        <path
          d="m59 27v2l-6 12h-6l8-16h2c1.1045695 0 2 .8954305 2 2z"
          id="Shape"
        />
        <path d="m49 25-8 16h-6l8-16z" id="Shape" />
        <path d="m37 25-8 16h-6l8-16z" id="Shape" />
        <path d="m25 25-8 16h-6l8-16z" id="Shape" />
        <path
          d="m13 25-8 16h-2c-1.1045695 0-2-.8954305-2-2v-2l6-12z"
          id="Shape"
        />
      </g>
    </g>
  </SvgIcon>
);

export default BarrierSvg;
